export default __webpack_public_path__ + "static/media/interior-two-mobile.60c4c9b7.jpg";